/* Accessible native menu: disclosure navigation + modal mobile drawer. */
(function(){
  'use strict';
  let previousFocus=null;
  const desktop=window.matchMedia('(min-width:1025px)');
  const phone=window.matchMedia('(max-width:767px), (max-width:1024px) and (max-height:500px)');
  let menuThemeColors=null;
  function syncMobileChrome(){
    const dialog=document.getElementById('SuttonMobileNav');
    const active=phone.matches&&dialog&&dialog.open;
    if(active&&menuThemeColors===null){
      // Older Safari uses theme-color; newer versions also sample the opaque CSS backdrop.
      menuThemeColors=Array.from(document.querySelectorAll('meta[name="theme-color"]')).map(meta=>({meta,content:meta.getAttribute('content')}));
      menuThemeColors.forEach(({meta})=>meta.setAttribute('content','#ffffff'));
    }else if(!active&&menuThemeColors!==null){
      menuThemeColors.forEach(({meta,content})=>{if(content===null)meta.removeAttribute('content');else meta.setAttribute('content',content);});
      menuThemeColors=null;
    }
  }
  phone.addEventListener('change',syncMobileChrome);
  let cartHeader=null,cartObserver=null;
  function syncCartCount(){
    const link=document.getElementById('cartLink');
    const badge=document.getElementById('CartCount');
    if(!link||!badge)return;
    const count=Number(badge.textContent.trim());
    if(!Number.isInteger(count)||count<0)return;
    const state=count>0?'filled':'empty';
    const label=(link.dataset.snavCartLabel||'Basket')+', '+(count>0?count+(count===1?' item':' items'):'empty');
    if(link.dataset.snavCartState!==state)link.dataset.snavCartState=state;
    if(link.getAttribute('aria-label')!==label)link.setAttribute('aria-label',label);
    if(badge.getAttribute('aria-hidden')!=='true')badge.setAttribute('aria-hidden','true');
  }
  function initCartCount(){
    const header=document.getElementById('header');
    if(header!==cartHeader){
      if(cartObserver)cartObserver.disconnect();
      cartHeader=header;
      if(header){
        cartObserver=new MutationObserver(syncCartCount);
        // Theme AJAX updates may replace the badge as well as its text. Do not
        // observe attributes: our accessible label and state cannot loop back.
        cartObserver.observe(header,{childList:true,characterData:true,subtree:true});
      }
    }
    syncCartCount();
  }
  function init(){
    initCartCount();
    document.querySelectorAll('[data-sutton-navigation]').forEach(root=>{
      if(root.dataset.snavReady)return;root.dataset.snavReady='true';
      const groups=Array.from(root.querySelectorAll('[data-snav-group]'));
      groups.forEach(group=>{
        let openTimer,closeTimer;
        group.addEventListener('toggle',()=>{if(group.open)groups.forEach(other=>{if(other!==group)other.open=false;});});
        group.querySelector('summary').addEventListener('pointerdown',()=>{clearTimeout(openTimer);clearTimeout(closeTimer);});
        group.addEventListener('keydown',event=>{clearTimeout(openTimer);clearTimeout(closeTimer);if(event.key==='Escape'&&group.open){event.preventDefault();event.stopPropagation();group.open=false;group.querySelector('summary').focus();}});
        if(root.classList.contains('snav-desktop')){
          group.addEventListener('pointerenter',event=>{if(event.pointerType!=='mouse')return;clearTimeout(closeTimer);openTimer=setTimeout(()=>{groups.forEach(other=>other.open=other===group);},350);});
          group.addEventListener('pointerleave',()=>{clearTimeout(openTimer);closeTimer=setTimeout(()=>{if(!group.contains(document.activeElement))group.open=false;},180);});
          group.addEventListener('focusout',()=>setTimeout(()=>{if(!group.contains(document.activeElement))group.open=false;},0));
        }
      });
      root.querySelectorAll('a[href]').forEach(link=>{try{const url=new URL(link.href,location.origin);if(url.origin===location.origin&&url.pathname===location.pathname)link.setAttribute('aria-current','page');}catch(_){}});
      if(root.tagName==='DIALOG'){
        root.querySelector('[data-snav-close]').addEventListener('click',()=>root.close());
        root.addEventListener('click',event=>{if(event.target!==root)return;const box=root.getBoundingClientRect();if(event.clientX<box.left||event.clientX>box.right||event.clientY<box.top||event.clientY>box.bottom)root.close();});
        root.addEventListener('close',()=>{document.documentElement.classList.remove('snav-locked');document.body.classList.remove('snav-locked');syncMobileChrome();document.querySelectorAll('[data-snav-open]').forEach(button=>button.setAttribute('aria-expanded','false'));if(previousFocus&&previousFocus.isConnected)previousFocus.focus();});
        root.addEventListener('click',event=>{const link=event.target.closest('a[href]');if(link)root.close();});
      }
    });
    document.querySelectorAll('[data-snav-open]').forEach(button=>{
      if(button.dataset.snavReady)return;button.dataset.snavReady='true';
      button.addEventListener('click',()=>{const dialog=document.getElementById(button.getAttribute('aria-controls'));if(!dialog)return;previousFocus=button;dialog.showModal();button.setAttribute('aria-expanded','true');document.documentElement.classList.add('snav-locked');document.body.classList.add('snav-locked');syncMobileChrome();dialog.querySelector('[data-snav-close]').focus();});
    });
  }
  document.addEventListener('click',event=>document.querySelectorAll('.snav-desktop [data-snav-group][open]').forEach(group=>{if(!group.contains(event.target))group.open=false;}));
  desktop.addEventListener('change',()=>{const dialog=document.getElementById('SuttonMobileNav');if(desktop.matches&&dialog&&dialog.open)dialog.close();document.querySelectorAll('.snav-desktop [data-snav-group]').forEach(group=>group.open=false);});
  window.addEventListener('pageshow',event=>{initCartCount();if(!event.persisted)return;const dialog=document.getElementById('SuttonMobileNav');if(dialog&&dialog.open)dialog.close();document.documentElement.classList.remove('snav-locked');document.body.classList.remove('snav-locked');syncMobileChrome();});
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
}());
